
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";

interface OrderDialogProps {
  selectedOrder: any;
  onClose: () => void;
  onDelete: () => void;
}

export const OrderDialog = ({ selectedOrder, onClose, onDelete }: OrderDialogProps) => {
  if (!selectedOrder) return null;

  return (
    <Dialog open={!!selectedOrder} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Sipariş Detayı</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-muted-foreground">Sipariş Tarihi</p>
              <p>{new Date(selectedOrder.created_at).toLocaleString('tr-TR')}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Durum</p>
              <p>{selectedOrder.status}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Müşteri</p>
              <p>{selectedOrder.name_surname}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Email</p>
              <p>{selectedOrder.email}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Telefon</p>
              <p>{selectedOrder.phone}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Tutar</p>
              <p>{selectedOrder.amount} TL</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-muted-foreground">Adres</p>
              <p>{selectedOrder.address}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-muted-foreground">Kart Bilgileri</p>
              <p>Kart Sahibi: {selectedOrder.card_holder}</p>
              <p>Son 4 Hane: {selectedOrder.card_last_four}</p>
            </div>
            <div className="col-span-2">
              <p className="text-sm text-muted-foreground">Sepet</p>
              {selectedOrder.basket_items && selectedOrder.basket_items.map((item: any, index: number) => (
                <div key={index} className="border-t pt-2 mt-2">
                  <p>{item.name}</p>
                  <p className="text-sm text-muted-foreground">
                    {item.price} TL x {item.quantity}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button
            variant="destructive"
            onClick={onDelete}
          >
            <Trash2 className="mr-2 h-4 w-4" />
            Siparişi Sil
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
